export const toPromise = async (callback) => {
    try {
        const response = await callback()
        if (response.ok) return Promise.resolve(response)

        return Promise.reject(response)
    } catch (e) {
        return Promise.reject(e)
    }
}
